import { render } from "./ScaleQuestion.vue?vue&type=template&id=5bf8fd28&scoped=true"
import script from "./ScaleQuestion.vue?vue&type=script&lang=js"
export * from "./ScaleQuestion.vue?vue&type=script&lang=js"

import "./ScaleQuestion.vue?vue&type=style&index=0&id=5bf8fd28&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf8fd28"]])

export default __exports__